import axios from 'axios';
import CustomSelect from '../form/custom-select';
import {initStocks} from '../../common/scripts/common';
import Observer from '../../common/scripts/observer';
import tplCommercesList from './templates/result/templates/commerces.twig';
import tplFlatsList from './templates/result/templates/flats.twig';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class FavoritesList {
    constructor() {
        /**
         * Обёртка блока с избранным
         */
        this.wrapper = null;

        /**
         * Адрес запросов
         * @type {string}
         */
        this.action = '';

        /**
         * Обёртка для списка квартир
         */
        this.contentWrapper = null;

        /**
         * Обёртка селекта с сортировкой квартир
         */
        this.selectSortWrapper = null;

        /**
         * Селект с сортировкой квартир
         */
        this.selectSort = null;

        /**
         * Кнопка подгрузки новых элементов избранного
         */
        this.showMoreBtn = null;

        /**
         * Скрывать/не скрывать забронированные квартиры
         * @type {boolean}
         */
        this.isHideLocked = false;

        /**
         * Класс который добавляется при подгрузке
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * Тип запроса
         * @type {string}
         */
        this.requestType = '';

        /**
         * Враппер контента результатов
         * * @type {string}
         */
        this.contentResults = null;

        this.processClass = 'is-process';
        this.activeClass = 'is-active';

        this.parent = null;
        this.estateType = 'flats';
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._subscribes();
        this._initSelect();
        this._initStocks();
        this._bindEvents();
    }

    /**
     * Получение дом-элементов
     * @private
     */
    _getElements() {
        this.action = this.wrapper.getAttribute('action') || 'tests/favorites.json';
        this.selectSortWrapper = this.wrapper.querySelector('.j-favorite-filter-sort');
        this.showMoreBtn = this.wrapper.querySelector('.j-favorite__more');
        this.showMoreBtnText = this.showMoreBtn ? this.showMoreBtn.querySelector('.j-favorite__more-text') : null;
        this.filter = this.wrapper.querySelector('.j-favorite-filter');
        // Враппер контента результатов
        this.contentResults = this.wrapper.querySelector('.j-favorites-result__content-wrapper');
        this.contentWrapper = this.contentResults?.querySelector('.flat-list');
        if (!this.contentWrapper) {
            this.estateType = 'commerces';
            this.contentWrapper = this.contentResults?.querySelector('.flat-list-commerce');
        }
        this.resultTableHead = this.contentResults?.querySelector('.j-favorites-result__table-head');
        this.viewButtons = Array.from(this.wrapper.querySelectorAll('.j-favorites-result__view'));
        // Сортировка
        this.sortInputs = Array.from(this.wrapper.querySelectorAll('.j-parametric-result__sort input')) || null;
        this.sortBtnMobile = this.wrapper.querySelector('.j-sort-mobile-btn') || null;
        this.sortBtnMobileClose = this.wrapper.querySelector('.j-parametric-sort-close') || null;
        this.sort = this.sortInputs?.find((item) => {
            return item.checked;
        })?.value || null;
    }

    _subscribes() {
        observer.subscribe('custom-select:instant-close', () => {
            this._closeSortMobile();
        });
    }

    /**
     * Инициализация селект
     * @private
     */
    _initSelect() {
        if (!this.selectSortWrapper) {
            return;
        }

        this.selectSort = new CustomSelect({
            elem: this.selectSortWrapper
        });

        this.selectSort.init();
    }

    /**
     * Навешивает обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.selectSortWrapper) {
            return;
        }

        this.selectSortWrapper?.addEventListener('change', (event) => {
            event.preventDefault();
            this.requestType = 'sort';
            this._send();
        });

        this.showMoreBtn?.addEventListener('click', (event) => {
            event.preventDefault();
            this.requestType = 'more';
            this._send();
        });

        if (this.viewButtons) {
            this.viewButtons.forEach((viewButton) => {
                viewButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    this._setView(viewButton);
                    this.setTagsHideCount();
                });
            });
        }

        this._showMoreFlatInfo();

        if (this.sortBtnMobile) {
            this.sortBtnMobile.addEventListener('click', this._openSortMobile.bind(this));
        }

        if (this.sortBtnMobileClose) {
            this.sortBtnMobileClose.addEventListener('click', this._closeSortMobile.bind(this));
        }
    }

    /**
     * Отправляет запрос
     * @private
     */
    _send() {
        if (!this.requestType) {
            return;
        }

        this.formData = this._collectData();

        this._toggleLoading(true);

        axios.post(this.action, this.formData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;

                    this._setTemplateData();
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._toggleLoading(false);
            });
    }

    /**
     * Собирает данные для отправки
     * @return {queryData} - объект данных для гет запроса
     * @private
     */
    _collectData() {
        const formData = new FormData();
        const options = this.selectSort.getOptions();
        const activeSelect = options.find((item) => {
            return item.checked;
        });

        formData.append('requestType', this.requestType);
        formData.append('sort', activeSelect.value);
        formData.append('discount', 'false');

        formData.append('estateType', this.estateType);

        this._addLimit(formData);

        return formData;
    }

    /**
     * Устанавливает данные в шаблон
     * @private
     */
    _setTemplateData() {
        const {flats} = this.data;

        this.requestType === 'sort' && Utils.clearHtml(this.contentWrapper);

        // Конвертируем стоимость
        flats.forEach((item) => {
            item.isFavoritePage = true;
            item.price = Utils.convertToDigit(item.price);

            if (item.mortgage) {
                item.mortgage = Utils.convertToDigit(item.mortgage);
            }
        });

        if (this.estateType === 'commerces') {
            Utils.insetContent(this.contentWrapper, tplCommercesList({flats}));
        } else {
            Utils.insetContent(this.contentWrapper, tplFlatsList({flats}));
        }

        this.setMoreButton();
        this._showMoreFlatInfo();
        this._initStocks();

        observer.publish('favorite:reInit');
    }

    /**
     * Показывает/скрывает загрузку
     * @param {boolean} show - показать/скрыть
     * @private
     */
    _toggleLoading(show) {
        const method = show ? 'add' : 'remove';

        this.wrapper.classList[method](this.loadingClass);
    }

    /**
     * Устанавливает новые данные в блок "Показать ещё"
     */
    setMoreButton() {
        if (!this.showMoreBtn) {
            return;
        }

        this.showMoreBtn.classList.toggle('is-hidden', !this.data?.more.more);

        if (this.data?.more?.count) {
            this.showMoreBtn.dataset.shown = this.data?.more.count;
        }

        if (this.showMoreBtnText && this.data?.more?.text) {
            this.showMoreBtnText.innerHTML = this.data?.more.text;
        }
    }

    /**
     * Заменяет контент
     * @param {Node} element - элемент, контент которого будет заменен
     * @param {string} html - новый контент
     * private
     */
    _replaceContent(element, html) {
        Utils.clearHtml(element);
        Utils.insetContent(element, html);
    }

    /**
     * Меняет вид вывода результатов
     * @param {HTMLElement} button - кнопка, на которую нажали
     * @private
     */
    _setView(button) {
        const view = button.dataset.view;

        this.viewButtons.forEach((viewButton) => {
            const method = button === viewButton ? 'add' : 'remove';

            viewButton.classList[method](this.activeClass);
        });

        this.contentResults.classList.add(this.processClass);
        this.contentResults.classList.toggle('favorites-result__flats_view_table', view === 'table');
        setTimeout(() => {
            this.contentResults.classList.remove(this.processClass);
        }, 0);

        if (!this.resultTableHead) {
            return;
        }

        if (this.contentResults.classList.contains('favorites-result__flats_view_table')) {
            this.resultTableHead.classList.add(this.activeClass);
        } else {
            this.resultTableHead.classList.remove(this.activeClass);
        }
    }

    setTagsHideCount() {
        const tagsList = Array.from(this.contentResults.querySelectorAll('.j-similar-tags'));

        tagsList.forEach((tagItem) => {
            if (tagItem.dataset.hidecount === '1') {
                tagItem.dataset.hidecount = '2';
            } else {
                tagItem.dataset.hidecount = '1';
            }

            this._initStocks();
        });
    }

    _initStocks() {
        const stockTags = [...document.querySelectorAll('.j-stock-tag')];

        initStocks(stockTags);
    }

    _showMoreFlatInfo() {
        this.showMoreFlatBtns =
                [...this.contentResults?.querySelectorAll('.j-favorites-flat__mobile-more:not([data-init])')];

        this.showMoreFlatBtns.forEach((showMoreFlatBtn) => {
            showMoreFlatBtn.dataset.init = true;

            showMoreFlatBtn.addEventListener('click', (event) => {
                event.preventDefault();
                showMoreFlatBtn.classList.toggle('is-active');
                showMoreFlatBtn.closest('.j-favorites-flat').classList.toggle('is-active');
            });
            showMoreFlatBtn.dataset.init = 'true';
        });
    }

    /**
     * Разворачивает сортировку КОСТЫЛЬ!!
     * @private
     */
    _openSortMobile() {
        if (!this.selectSort) {
            return;
        }

        this.sortBtnMobile.classList.add('is-active');
        document.querySelector('.j-wrapper').classList.add('is-active');
        this.selectSort.isOpen = true;
        this.selectSort.elem.classList.add(this.openClass);
        this.selectSort.content.style.height = `${this.selectSort.content.scrollHeight}px`;
        this.selectSort._fixBody();
    }

    /**
     * Сворачивает сортировку КОСТЫЛЬ!!
     * @private
     */
    _closeSortMobile() {
        if (!this.selectSort) {
            return;
        }

        this.sortBtnMobile.classList.remove('is-active');
        document.querySelector('.j-wrapper').classList.remove('is-active');

        this.selectSort.isOpen = false;
        this.selectSort.content.style.height = '0px';
        setTimeout(() => {
            this.selectSort.content.style.height = '';
        }, 300);
        this.selectSort.elem.classList.remove(this.selectSort.openClass);
        this.selectSort._unfixBody();
    }

    /**
     * Добавляет кол-во выведенных квартир в данные для отправки
     * @param {Object} data - объект данных
     * @private
     */
    _addLimit(data) {
        if (!this.showMoreBtn) {
            return;
        }

        data.append('shown', this.showMoreBtn.dataset.shown);
    }
}

export default FavoritesList;
